$(function () {

    let up = false
    let down = false
    let marginTop = 0
    let mainHeight = $('main').innerHeight()
    let oldScrollGlobal = 0
    let newScrollGlobal = 0

    $(document).scrollTop(0)


    $('.js-burger-active').click( function () {

        toggleMenu()

    })

    $('.js-burger-icon').click( function () {

        toggleMenu()

    })


    $('.js-anchor').each( function () {
        selectActiveLink()
    })


    $(window).scroll( function () {

        newScrollGlobal = $(document).scrollTop()

        if ($(document).scrollTop() > 300) {

            $('.bp-single__burger').addClass('scrolled')

        } else {

            $('.bp-single__burger').removeClass('scrolled')

            closeMenu()

        }

        selectActiveLink()
        stickySidebar(newScrollGlobal, oldScrollGlobal)

        oldScrollGlobal = $(document).scrollTop()

    })

    $('.js-anchor-link').click( function (e) {

        e.preventDefault()

    })

    $('.js-burger-link').click( function () {

        toggleMenu()

    })

    $('.js-popup-open').click( function (e) {

        e.preventDefault()

        openPopup($(this).data('modal-button'))

    })

    $('.js-popup-close').click( function () {

        closePopup($(this).closest('.js-popup').data('modal'))

    })

    function toggleMenu() {

        $('.js-burger-active').slideToggle(150)
        $('.js-burger-wrapper').slideToggle(150)

        $('.js-burger-icon').toggleClass('active')
        $('html').toggleClass('stop-scroll')

    }

    function closeMenu () {

        $('.js-burger-active').slideDown(150)
        $('.js-burger-wrapper').slideUp(150)

        $('.js-burger-icon').removeClass('active')

    }

    function selectActiveLink() {
        $('.js-anchor').each( function () {
            let currentId = ''
            if ($(this).offset().top + $(this).next().innerHeight() >= $(window).scrollTop()
                && $(this).offset().top - 50 <= $(window).scrollTop()) {
                if (currentId = '' || currentId !== $(this).attr('id')) {
                    currentId = $(this).attr('id')
                    $('.js-anchor-link').parent().removeClass('active')
                    $('.js-anchor-link[href="#' + currentId + '"]').parent().addClass('active')
                }
            }
        })
    }

    function openPopup(modalId) {

        let activePopup = $('.js-popup[data-modal="' + modalId + '"]')

        activePopup.fadeIn(0).css({display: 'flex'})

        $('html').addClass('stop-scroll')

        if ($('.popup__video', activePopup).length) {

            let loc = $('iframe', activePopup).attr('src')

            $('iframe', activePopup).attr('src', loc.replace("?autoplay=0", "?autoplay=1"))

        }

    }

    function closePopup(modalId) {

        let activePopup = $('.js-popup[data-modal="' + modalId + '"]')

        activePopup.fadeOut(0)

        $('html').removeClass('stop-scroll')

        if ($('.popup__video', activePopup).length) {

            let loc = $('iframe', activePopup).attr('src')

            $('iframe', activePopup).attr('src', loc.replace("?autoplay=1", "?autoplay=0"))

        }

    }



    function stickySidebar(newScroll, oldScroll) {

        if ($('.js-sidebar').height() < $(window).height()) {


            $('.js-sidebar').addClass('sticky-scroll')

        } else {

            clingTo( newScroll, oldScroll )

        }

    }

    function clingTo( newScroll, oldScroll ) {

        let offsetParent = $('.js-sidebar').parent().offset().top
        let boxHeight = $('.js-sidebar').height()

        if (newScroll - oldScroll > 0) {

            up = false

            if (newScroll - offsetParent - marginTop - boxHeight + $(window).height() >= 0) {

                marginTop = $('.js-sidebar').offset().top - offsetParent

                $('.js-sidebar')
                    .removeClass('fix-top')
                    .addClass('fix-bot')
                    .css({marginTop: 0, width: $('.js-sidebar').parent().width() + 'px'})

            }


            if (newScroll - offsetParent - marginTop + $(window).height() > 0 && !down) {

                down = true

                $('.js-sidebar')
                    .removeClass('fix-top')
                    .removeClass('fix-bot')
                    .css({marginTop: marginTop + 'px'})

            }

            if ( newScroll + $(window).height() - mainHeight - 12 >= 0) {

                $('.js-sidebar')
                    .removeClass('fix-top')
                    .removeClass('fix-bot')
                    .css({marginTop: marginTop + 'px'})

            }

        } else {

            down = false

            if (newScroll - marginTop - offsetParent + 68  <= 0) {

                marginTop = $('.js-sidebar').offset().top - offsetParent

                $('.js-sidebar')
                    .addClass('fix-top')
                    .removeClass('fix-bot')
                    .css({marginTop: 0, width: $('.js-sidebar').parent().width() + 'px'})

            }

            if (!up && newScroll - marginTop - offsetParent > 0) {

                up = true

                $('.js-sidebar')
                    .removeClass('fix-bot')
                    .css({marginTop: marginTop + 'px'})

            }

            if ($('.js-sidebar').offset().top - offsetParent <= 0) {

                $('.js-sidebar')
                    .removeClass('fix-bot')
                    .removeClass('fix-top')
                    .css({marginTop: 0})
                marginTop = 0

            }

        }

    }

})
